import type { SegmentDTO } from '@next-space/fe-api-idl';
import { TextType } from '@next-space/fe-api-idl';
import dayjs from 'dayjs';
import { DATE_FORMAT, DATE_TIME_FORMAT } from 'src/common/const';
import { readDateFromDateSegment } from 'src/editor/utils/segments';
import { getViewFormat } from 'src/hooks/block/get-view-format';
import type { DateSegmentInfo } from './table-view/cell/types';

/** 通过segment获取date */
export const segmentsToDateValue = (segment?: SegmentDTO): DateSegmentInfo | undefined => {
  if (!segment) return;

  const date = dayjs(readDateFromDateSegment(segment));
  const endDate = segment.endDate ? dayjs(readDateFromDateSegment(segment, true)) : undefined;
  if (isNaN(date.toDate().getTime())) return;
  let endDateStr = '';
  if (endDate) {
    endDateStr += ` → ${endDate.format(DATE_FORMAT)}`;
  }
  if (segment.type === TextType.DATE) {
    return {
      dateString: date.format(DATE_FORMAT) + endDateStr,
      timestamp: date.valueOf(),
      endDateString: endDate?.format(DATE_FORMAT),
      endTimestamp: endDate?.valueOf(),
      textType: TextType.DATE,
    };
  }
  if (segment.type === TextType.DATETIME) {
    return {
      dateString: date.format(DATE_TIME_FORMAT) + endDateStr,
      timestamp: date.valueOf(),
      endDateString: endDate?.format(DATE_FORMAT),
      endTimestamp: endDate?.valueOf(),
      textType: TextType.DATETIME,
    };
  }
};

export const getGroupUniqueId = (viewId: string, groupName = 'ungroup', isSubGroup = false) => {
  const { groupBy, subGroupBy } = getViewFormat(viewId) ?? {};
  return `viewId:${viewId};groupProperty:${
    isSubGroup ? subGroupBy?.property : groupBy?.property
  };groupName:${groupName}`;
};
